/**
 * Type de lieu OD
 */
export enum TypeLieu {
    TYPE_LIEU_RESIDENCE_FAMILIALE = 1,
    TYPE_LIEU_RESIDENCE_ADMINISTRATIVE = 2,
    TYPE_LIEU_ETABLISSEMENT = 3,
    TYPE_LIEU_AUTRE = 4
}